(function(){
  const script = document.currentScript;
  const root = script && script.previousElementSibling && script.previousElementSibling.matches("style")
    ? script.previousElementSibling.previousElementSibling
    : document.querySelector("[data-vmq]:not([data-vmq-ready='true'])");
  if (!root || root.dataset.vmqReady === "true") return;
  root.dataset.vmqReady = "true";

  const labels = {
    floorType: {
      "plak-pvc": "Plak PVC",
      "click-pvc": "Click PVC",
      "laminaat": "Laminaat",
      "advies": "Advies gewenst"
    },
    typeShort: {
      "plak-pvc": "Plak",
      "click-pvc": "Click",
      "laminaat": "Laminaat",
      "advies": "Advies"
    },
    pattern: {
      "rechte-stroken": "Rechte stroken",
      "visgraat": "Visgraat",
      "walvisgraat": "Walvisgraat",
      "tegels": "Tegels",
      "hongaarse-punt": "Hongaarse- of Weense punt"
    },
    yesNo: { ja: "Ja", nee: "Nee" }
  };

  const state = {
    floorType: "",
    pattern: "",
    brand: "",
    product: "",
    surface: 50,
    layService: "",
    legPostcode: "",
    legAvailable: null, // null = nog niet gecheckt, true = dekking, false = geen legger in regio
    leveling: "",
    subfloor: "",
    levelMm: "",
    plinth: "",
    plinthMeters: 1,
    plinthMount: ""
  };

  const form = root.querySelector("form");
  const steps = Array.from(root.querySelectorAll("[data-vmq-step]"));

  // Design 2: wikkel de rechterkolom-inhoud (alles behalve de titel) in één container,
  // zodat de stap netjes 2 kolommen is: links tekst, rechts gecentreerde content.
  if (root.getAttribute("data-design") === "2") {
    steps.forEach((step) => {
      const key = step.getAttribute("data-vmq-step");
      if (key === "product" || key === "contact") return;
      if (step.querySelector(":scope > .vmq-d2-right")) return;
      const wrap = document.createElement("div");
      wrap.className = "vmq-d2-right";
      Array.from(step.children).forEach((c) => {
        if (c.classList.contains("vmq-question") || c.classList.contains("vmq-intro")) return;
        wrap.appendChild(c);
      });
      step.appendChild(wrap);
    });
  }
  const productList = root.querySelector("[data-vmq-product-list]");
  const plinthList = root.querySelector("[data-vmq-plinth-list]");
  const productEmpty = root.querySelector("[data-vmq-products-empty]");
  const previewImg = root.querySelector("[data-vmq-preview-img]");
  const previewEmpty = root.querySelector("[data-vmq-preview-empty]");
  const previewFallback = ((previewImg && previewImg.dataset.vmqPreviewFallback) || "").trim();
  // Als een productafbeelding niet laadt, val terug op de vloerfoto (nooit een kapot icoon tonen).
  if (previewImg && previewFallback) {
    previewImg.addEventListener("error", function () {
      if (previewImg.src !== previewFallback) previewImg.src = previewFallback;
    });
  }
  // Cache van al voorgeladen afbeeldings-URL's, zodat wisselen tussen vloeren direct gaat.
  const preloadCache = {};
  function preload(url) {
    if (!url || preloadCache[url]) return;
    preloadCache[url] = new Image();
    preloadCache[url].src = url;
  }
  const productQuestion = root.querySelector("[data-vmq-product-question]");
  const productContext = root.querySelector("[data-vmq-product-context]");
  const floorContexts = Array.from(root.querySelectorAll("[data-vmq-context]"));
  const surfaceInput = root.querySelector("[data-vmq-surface-input]");
  const surfaceRange = root.querySelector("[data-vmq-surface-range]");
  const plinthInput = root.querySelector("[data-vmq-plinth-input]");
  const plinthRange = root.querySelector("[data-vmq-plinth-range]");
  const contactError = root.querySelector("[data-vmq-contact-error]");
  const surfaceError = root.querySelector("[data-vmq-surface-error]");
  const legPostcodeInput = root.querySelector("[data-vmq-legservice-postcode]");
  const legStatus = root.querySelector("[data-vmq-legservice-status]");
  const legYesInput = root.querySelector("[data-vmq-legservice-yes]");
  const legYesOption = root.querySelector("[data-vmq-legservice-yes-option]");
  const contactPostcodeInput = root.querySelector('[name="contact[postcode]"]');
  const progressFill = root.querySelector("[data-vmq-progress-fill]");
  const progressCurrent = root.querySelector("[data-vmq-progress-current]");
  const progressTotal = root.querySelector("[data-vmq-progress-total]");
  let currentStep = "floorType";

  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function readItems(selector) {
    const items = [];
    const seen = new Map();
    root.querySelectorAll(selector).forEach((el) => {
      const item = {
        title: el.dataset.title || "",
        subtitle: el.dataset.subtitle || "",
        vendor: el.dataset.vendor || "",
        type: el.dataset.type || "",
        tags: el.dataset.tags || "",
        collection: el.dataset.collection || "",
        variantId: el.dataset.variantId || "",
        productId: el.dataset.productId || "",
        sku: el.dataset.sku || "",
        price: parseInt(el.dataset.price || "0", 10) || 0,
        url: el.dataset.url || "",
        image: el.dataset.image || "",
        thumb: el.dataset.thumb || ""
      };
      item.search = normalize([item.title, item.subtitle, item.vendor, item.type, item.tags, item.collection, item.sku].join(" "));
      const key = item.variantId || item.title;
      if (seen.has(key)) {
        const existing = seen.get(key);
        existing.search = `${existing.search} ${item.search}`;
        existing.collection = `${existing.collection} ${item.collection}`;
        return;
      }
      seen.set(key, item);
      items.push(item);
    });
    return items;
  }

  let products = readItems("[data-vmq-source-product]");
  const plinths = readItems("[data-vmq-source-plinth]");

  // PRODUCT-MODUS: op een productpagina zijn vloertype/patroon/product al bekend
  // (data-vmq-prefill-* uit Liquid); de flow begint dan direct bij de m²-stap.
  const prefill = root.dataset.vmqPrefillVariant
    ? {
        variantId: root.dataset.vmqPrefillVariant,
        title: root.dataset.vmqPrefillTitle || "",
        sku: root.dataset.vmqPrefillSku || "",
        price: parseFloat(root.dataset.vmqPrefillPrice || "0") || 0,
        image: root.dataset.vmqPrefillImage || "",
        type: root.dataset.vmqPrefillType || "",
        pattern: root.dataset.vmqPrefillPattern || "",
      }
    : null;
  if (prefill) {
    products.push({
      title: prefill.title,
      subtitle: prefill.sku ? "SKU: " + prefill.sku : "",
      vendor: "", type: prefill.type, tags: "", collection: "",
      variantId: prefill.variantId, productId: "",
      sku: prefill.sku, price: prefill.price, url: "",
      image: prefill.image, thumb: prefill.image,
      search: normalize(`${prefill.title} ${prefill.sku}`),
    });
    state.floorType = prefill.type;
    state.pattern = prefill.pattern;
    state.brandChosen = true;
    state.product = prefill.variantId;
  }

  // ── Vloeren ophalen via Mastermind ─────────────────────────────────────────
  // De ingebedde [data-vmq-source-product]-lijst is slechts een fallback-seed (door
  // Liquid gelimiteerd). De echte bron is de Mastermind-offerte-API: die geeft op merk
  // + vloertype + legpatroon de VOLLEDIGE set vloeren terug — merk uit het merk-veld,
  // zonder 40-limiet. Zodra die respons binnen is, vervangt hij de seed.
  const OFFERTE_ENDPOINT = "https://vm-keuzehulp-proxy.faruk-01b.workers.dev/api/offerte/producten";
  // Eén promise-cache voor alle lijst-fetches: dedupet óók gelijktijdige aanvragen
  // (merkfilter + productstap vroegen voorheen dezelfde data 2-3x tegelijk op).
  const listCache = {};
  const listKlaar = {}; // key → opgeloste lijst, voor synchroon (flitsvrij) hergebruik
  let serverLoaded = false;
  let loadedKey = "";
  let loadingProducts = false;
  let loadSeq = 0;

  // Geoptimaliseerde Shopify-CDN-variant (voorkomt dat we de volledige resolutie laden).
  function sized(url, w) {
    if (!url) return "";
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + w;
  }

  function mapServerItem(p) {
    const img = p.image || "";
    return {
      title: p.title || "",
      subtitle: p.sku ? "SKU: " + p.sku : "",
      vendor: p.merk || "",
      type: p.type || "",
      tags: "",
      collection: "",
      variantId: String(p.variantId || ""),
      productId: String(p.productId || ""),
      sku: p.sku || "",
      price: p.price || 0,
      url: p.handle ? "/products/" + p.handle : "",
      image: img ? sized(img, 1000) : "",
      thumb: img ? img + (img.indexOf("?") === -1 ? "?" : "&") + "width=200&height=140&crop=center" : ""
    };
  }

  function fetchList(type, pattern, merk) {
    const key = [type || "", pattern || "", merk || ""].join("|");
    if (!listCache[key]) {
      const params = new URLSearchParams({ type: type || "", pattern: pattern || "", merk: merk || "" });
      listCache[key] = fetch(`${OFFERTE_ENDPOINT}?${params.toString()}`, { headers: { Accept: "application/json" } })
        .then((res) => {
          if (!res.ok) throw new Error("offerte-endpoint " + res.status);
          return res.json();
        })
        .then((data) => {
          const list = (data.producten || []).map(mapServerItem);
          listKlaar[key] = list;
          return list;
        })
        .catch((e) => { delete listCache[key]; throw e; });
    }
    return listCache[key];
  }

  async function loadProducts() {
    if (!state.floorType || state.floorType === "advies") return;
    const key = [state.floorType, state.pattern || "", state.brand || ""].join("|");
    if (loadedKey === key && serverLoaded) return;
    const seq = ++loadSeq;
    loadingProducts = true;
    renderProducts();
    try {
      const list = await fetchList(state.floorType, state.pattern, state.brand);
      // Trage respons mag een nieuwere keuze niet overschrijven.
      if (seq !== loadSeq) return;
      products = list;
      serverLoaded = true;
      loadedKey = key;
    } catch (e) {
      if (seq !== loadSeq) return;
      serverLoaded = false; // val terug op de ingebedde seed + clientfilter
    }
    loadingProducts = false;
    renderProducts();
  }

  // Toont bij de merkstap alleen merken waarvoor daadwerkelijk producten bestaan voor het
  // gekozen type + patroon. Al gecachet → direct toepassen (geen flits); anders een nette
  // laadstatus i.p.v. "eerst alle merken tonen en er dan een paar laten verdwijnen".
  // Bij een fout tonen we uit voorzorg alle merken.
  function pasMerkenToe(list, brandInputs) {
    const merken = new Set(list.map((i) => String(i.vendor || "").trim().toLowerCase()).filter(Boolean));
    brandInputs.forEach((input) => {
      const opt = input.closest(".vmq-option");
      if (!opt) return;
      if (input.value === "geen-voorkeur") { opt.style.display = ""; return; }
      const beschikbaar = merken.has(input.value.trim().toLowerCase());
      opt.style.display = beschikbaar ? "" : "none";
      if (!beschikbaar && input.checked) {
        input.checked = false;
        if (state.brand === input.value) { state.brand = ""; state.brandChosen = false; }
      }
    });
  }

  async function filterBrands() {
    const brandInputs = Array.from(root.querySelectorAll('input[name="vmq-brand"]'));
    if (!brandInputs.length) return;
    const opties = root.querySelector('[data-vmq-step="brand"] .vmq-options');
    const toonAlles = () => brandInputs.forEach((input) => { const o = input.closest(".vmq-option"); if (o) o.style.display = ""; });
    if (!state.floorType || state.floorType === "advies") { toonAlles(); return; }

    const key = [state.floorType, state.pattern || "", ""].join("|");
    if (listKlaar[key]) { pasMerkenToe(listKlaar[key], brandInputs); updateNav(); return; }

    // Laadstatus: opties even verbergen tot bekend is welke merken bestaan.
    let loader = null;
    if (opties) {
      opties.style.visibility = "hidden";
      loader = document.createElement("p");
      loader.className = "vmq-empty";
      loader.textContent = "Merken voor jouw keuze ophalen…";
      opties.parentNode.insertBefore(loader, opties);
    }
    try {
      const list = await fetchList(state.floorType, state.pattern, "");
      pasMerkenToe(list, brandInputs);
    } catch (e) {
      toonAlles();
    } finally {
      if (opties) opties.style.visibility = "";
      if (loader) loader.remove();
    }
    updateNav();
  }

  function has(item, words) {
    return words.some((word) => item.search.includes(word));
  }

  function matchesFloorType(item) {
    if (!state.floorType || state.floorType === "advies") return true;
    if (state.floorType === "plak-pvc") return has(item, ["plak pvc", "dryback", "plakpvc", "plak"]) && has(item, ["pvc"]);
    if (state.floorType === "click-pvc") return has(item, ["click pvc", "klik pvc", "clickpvc", "klikpvc"]) || (has(item, ["click", "klik"]) && has(item, ["pvc"]) && !has(item, ["laminaat"]));
    if (state.floorType === "laminaat") return has(item, ["laminaat"]);
    return true;
  }

  function matchesPattern(item) {
    if (!state.pattern) return true;
    if (state.pattern === "rechte-stroken") return !has(item, ["visgraat", "walvisgraat", "hongaarse", "weense", "chevron", "tegel", "tile"]);
    if (state.pattern === "visgraat") return has(item, ["visgraat"]) && !has(item, ["walvisgraat"]);
    if (state.pattern === "walvisgraat") return has(item, ["walvisgraat", "visgraat xl"]);
    if (state.pattern === "tegels") return has(item, ["tegel", "tegels", "tile", "stone"]);
    if (state.pattern === "hongaarse-punt") return has(item, ["hongaarse", "weense", "chevron", "punt"]);
    return true;
  }

  function matchesBrand(item) {
    if (!state.brand) return true;
    return item.search.includes(normalize(state.brand));
  }

  function filteredProducts() {
    // Server (Mastermind) filterde al op merk + type + patroon → direct tonen.
    if (serverLoaded) return products.slice(0, 250);
    // Fallback op de ingebedde seed: clientfilter (merk strikt, geen terugval).
    let pool = products.slice();
    const typed = pool.filter(matchesFloorType);
    if (typed.length) pool = typed;
    const patterned = pool.filter(matchesPattern);
    if (patterned.length) pool = patterned;
    if (state.brand) pool = pool.filter(matchesBrand);
    return pool.slice(0, 60);
  }

  function makeProductCard(item, groupName, key) {
    const label = document.createElement("label");
    label.className = `vmq-product-card${item.thumb ? "" : " vmq-product-card--noimage"}`;

    const input = document.createElement("input");
    input.type = "radio";
    input.name = groupName;
    input.value = item.variantId;
    input.dataset.vmqInput = key;

    const radio = document.createElement("span");
    radio.className = "vmq-radio";

    const info = document.createElement("span");
    const title = document.createElement("strong");
    title.textContent = item.title;
    info.appendChild(title);
    const sub = document.createElement("small");
    sub.textContent = item.subtitle || [item.vendor, item.sku ? `SKU: ${item.sku}` : ""].filter(Boolean).join(" · ");
    if (sub.textContent) info.appendChild(sub);

    label.append(input, radio);

    // Afbeelding vóór de titel.
    if (item.thumb) {
      const img = document.createElement("img");
      img.src = item.thumb;
      img.alt = item.title;
      img.loading = "lazy";
      img.width = 180;
      img.height = 120;
      label.appendChild(img);
    }
    label.appendChild(info);

    return label;
  }

  // Kaarten in porties renderen: honderden kaarten ineens maken de productstap traag.
  const CHUNK = 60;

  function renderProducts() {
    if (!productList) return;
    productList.innerHTML = "";
    productList.vmqAppendMore = null;

    if (loadingProducts) {
      const loader = document.createElement("p");
      loader.className = "vmq-empty";
      loader.textContent = "Vloeren laden…";
      productList.appendChild(loader);
      if (productEmpty) productEmpty.hidden = true;
      return;
    }

    const advice = {
      title: "Ik wil geadviseerd worden",
      subtitle: "Laat Vloerenmarkt de juiste vloer meerekenen",
      variantId: "advies",
      productId: "advies",
      sku: "",
      image: "",
      thumb: ""
    };

    const list = filteredProducts();
    // Alleen de fallback + de eerste paar voorbeeldfoto's voorladen. (Voorheen werden
    // ALLE foto's op volle grootte voorgeladen — dat maakte de hele module traag.)
    if (previewFallback) preload(previewFallback);
    list.slice(0, 4).forEach((item) => preload(item.image));

    // Auto-selecteer het eerste product zodat er meteen een preview/afbeelding is
    // (anders lijkt de stap leeg/kapot). Alleen op de productstap, en alleen als er
    // nog niets geldigs gekozen is (dus niet voortijdig bij het laden van de pagina).
    const known = list.some((item) => item.variantId === state.product) || state.product === "advies";
    if (!known && list.length && currentStep === "product") state.product = list[0].variantId;

    let rendered = 0;
    let adviceAdded = false;
    const appendCard = (item) => {
      const card = makeProductCard(item, "vmq-product", "product");
      const input = card.querySelector("input");
      if (input && input.value === (state.product || "")) input.checked = true;
      productList.appendChild(card);
    };
    const appendChunk = () => {
      if (adviceAdded) return;
      list.slice(rendered, rendered + CHUNK).forEach(appendCard);
      rendered = Math.min(rendered + CHUNK, list.length);
      if (rendered >= list.length) {
        appendCard(advice);
        adviceAdded = true;
      }
    };
    // Render minstens t/m het geselecteerde product, zodat de keuze zichtbaar blijft.
    const selIdx = list.findIndex((item) => item.variantId === (state.product || ""));
    const firstTarget = Math.max(CHUNK, selIdx + 1);
    do { appendChunk(); } while (!adviceAdded && rendered < Math.min(firstTarget, list.length));
    productList.vmqAppendMore = appendChunk;

    productEmpty.hidden = list.length > 0;
    updateUi();
  }

  if (productList) {
    productList.addEventListener("scroll", () => {
      if (typeof productList.vmqAppendMore === "function"
        && productList.scrollTop + productList.clientHeight > productList.scrollHeight - 320) {
        productList.vmqAppendMore();
      }
    });
  }

  // Moderne MDF plint gebroken wit 12x90 is de best verkochte plint: badge + bovenaan.
  // "Geen plinten nodig" gaat naar onderen, zodat de aanrader als eerste in beeld staat.
  function isTopPlint(item) {
    const s = item.search;
    return s.includes("moderne mdf") && s.includes("gebroken wit") && (s.includes("12 x 90") || s.includes("12x90") || s.includes("12 90"));
  }

  function renderPlinths() {
    if (!plinthList) return;
    plinthList.innerHTML = "";
    const rank = (item) => (isTopPlint(item) ? 0 : item.variantId === "none" ? 2 : 1);
    plinths.slice().sort((a, b) => rank(a) - rank(b)).forEach((item) => {
      const card = makeProductCard(item, "vmq-plinth", "plinth");
      if (isTopPlint(item)) {
        const badge = document.createElement("span");
        badge.className = "vmq-badge";
        badge.textContent = "Meest gekozen";
        card.appendChild(badge);
      }
      plinthList.appendChild(card);
    });
  }

  function getSelectedProduct() {
    if (!state.product || state.product === "advies") return null;
    return products.find((item) => item.variantId === state.product) || null;
  }

  function getSelectedPlinth() {
    if (!state.plinth) return null;
    return plinths.find((item) => item.variantId === state.plinth) || null;
  }

  function activeOrder() {
    const order = [];
    if (!prefill) {
      order.push("floorType");
      if (state.floorType !== "advies") order.push("pattern", "brand", "product");
    }
    order.push("surface", "layService");
    // Laminaat wordt nooit geëgaliseerd → egaliseren-stap (en dekvloer/mm) overslaan.
    if (state.floorType !== "laminaat") {
      order.push("leveling");
      if (state.leveling === "ja") order.push("subfloor", "levelMm");
    }
    order.push("plinth");
    if (state.plinth && state.plinth !== "none") {
      order.push("plinthMeters");
      // Montage kan alleen als wij ook leggen: bij "geen legservice" vervalt de montagestap.
      if (state.layService === "ja") order.push("plinthMount");
    }
    order.push("contact");
    return order;
  }

  function updateProgress() {
    const order = activeOrder();
    const idx = Math.max(0, order.indexOf(currentStep));
    const total = order.length;
    const pct = Math.round(((idx + 1) / total) * 100);
    if (progressFill) progressFill.style.width = pct + "%";
    if (progressCurrent) progressCurrent.textContent = idx + 1;
    if (progressTotal) progressTotal.textContent = total;
  }

  function showStep(step, shouldScroll = true) {
    const order = activeOrder();
    if (!order.includes(step)) step = order[0];
    currentStep = step;
    steps.forEach((el) => el.classList.toggle("is-active", el.dataset.vmqStep === step));
    updateUi();
    if (step === "brand") filterBrands();
    if (step === "product") loadProducts();
    // Alleen scrollen als de module echt uit beeld staat; anders blijft de pagina stil.
    // De CSS scroll-margin-top houdt daarbij ruimte vrij voor de zwevende site-header.
    if (shouldScroll) {
      if (isModal) {
        root.scrollTo({ top: 0, behavior: "smooth" }); // de overlay is zelf de scroller
      } else {
        const r = root.getBoundingClientRect();
        if (r.top < 60 || r.top > window.innerHeight * 0.5) {
          root.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    }
  }

  function selectedLabel(key) {
    if (key === "floorType") return labels.floorType[state.floorType] || "";
    if (key === "pattern") return labels.pattern[state.pattern] || "";
    if (key === "layService") return labels.yesNo[state.layService] || "";
    if (key === "leveling") return labels.yesNo[state.leveling] || "";
    return state[key] || "";
  }

  function contextText() {
    const pattern = selectedLabel("pattern");
    const type = labels.typeShort[state.floorType] || selectedLabel("floorType");
    return [pattern, type].filter(Boolean).join(" - ") || "Vloer";
  }

  function isValidStep(step) {
    if (step === "floorType") return Boolean(state.floorType);
    if (step === "pattern") return Boolean(state.pattern);
    if (step === "brand") return Boolean(state.brand) || Boolean(state.brandChosen);
    if (step === "product") return Boolean(state.product);
    if (step === "surface") return state.surface >= 50 && state.surface <= 500;
    if (step === "layService") {
      if (!state.layService) return false;
      // "Ja" mag alleen door bij min. 50 m² én bevestigde legger-dekking in de regio.
      if (state.layService === "ja") return state.surface >= 50 && state.legAvailable === true;
      return true;
    }
    if (step === "leveling") return Boolean(state.leveling);
    if (step === "subfloor") return Boolean(state.subfloor);
    if (step === "levelMm") return Boolean(state.levelMm);
    if (step === "plinth") return Boolean(state.plinth);
    if (step === "plinthMeters") return state.plinthMeters >= 1 && state.plinthMeters <= 250;
    if (step === "plinthMount") return Boolean(state.plinthMount);
    if (step === "contact") return validateContact(false);
    return true;
  }

  function updateNav() {
    root.querySelectorAll("[data-vmq-next]").forEach((button) => {
      const step = button.closest("[data-vmq-step]")?.dataset.vmqStep;
      button.disabled = !isValidStep(step);
    });
  }

  function updatePreview() {
    if (!previewImg || !previewEmpty) return; // productstap ontbreekt in product-modus
    const product = getSelectedProduct();
    const src = (product && product.image) || previewFallback;
    if (src) {
      if (previewImg.src !== src) previewImg.src = src;
      previewImg.alt = (product && product.title) || "Voorbeeld vloer";
      previewImg.hidden = false;
      previewEmpty.hidden = true;
      return;
    }
    previewImg.hidden = true;
    previewEmpty.hidden = false;
  }

  // Egaline-advies per dekvloer: bepaalt welke mm-optie de "Aanbevolen"-badge krijgt.
  const EGALINE_ADVIES = {
    "Zandcement/beton dekvloer": "3mm",
    "Anhydriet dekvloer": "3mm",
    "Houten draagvloer": "6mm",
    "Bestaande tegelvloer": "6mm",
    "Bestaande gietvloer": "3mm",
    "Fermacell": "3mm"
  };

  function updateUi() {
    floorContexts.forEach((el) => { el.textContent = contextText(); });
    const mmAdvies = EGALINE_ADVIES[state.subfloor] || "";
    root.querySelectorAll("[data-vmq-mm-badge]").forEach((badge) => {
      badge.hidden = !mmAdvies || badge.dataset.vmqMmBadge !== mmAdvies;
    });
    if (productContext) productContext.textContent = [state.brand, normalize(contextText())].filter(Boolean).join(" - ");
    if (productQuestion) productQuestion.textContent = state.brand ? `Welke ${state.brand} vloer heeft u op het oog?` : "Welke vloer heeft u op het oog?";

    const noLevelingText = root.querySelector("[data-vmq-leveling-no-text]");
    if (noLevelingText) {
      noLevelingText.textContent = state.floorType === "plak-pvc"
        ? "Voor plak PVC is een geëgaliseerde dekvloer vereist, wanneer wij dit niet doen zou iemand anders dit moeten verzorgen."
        : "Als de bestaande vloer voldoende vlak is nemen we egaliseren niet mee in de offerte.";
    }

    if (surfaceError) surfaceError.hidden = !(state.layService === "ja" && state.surface < 50);
    updatePreview();
    updateHidden();
    updateNav();
    updateProgress();
  }

  // ── Legservice-postcodecheck ────────────────────────────────────────────────
  // Legservice bieden we alleen aan als er in de regio van de klant een actieve
  // legger-partner zit (gekoppeld aan het partnerportaal). De "Ja"-optie blijft
  // uitgeschakeld tot een postcode positieve dekking oplevert.
  const LEGSERVICE_ENDPOINT = OFFERTE_ENDPOINT.replace("/producten", "/legservice");
  let legSeq = 0;
  let legTimer = null;
  let legLastPc = null; // laatste postcode waarvoor we een definitief dekkings-antwoord hebben

  function setLegStatus(text, kind) {
    if (!legStatus) return;
    legStatus.textContent = text || "";
    legStatus.hidden = !text;
    if (kind) legStatus.setAttribute("data-state", kind);
    else legStatus.removeAttribute("data-state");
  }

  function setLegYesEnabled(enabled) {
    if (legYesInput) legYesInput.disabled = !enabled;
    if (legYesOption) legYesOption.classList.toggle("vmq-option--disabled", !enabled);
    if (!enabled && legYesInput && legYesInput.checked) {
      legYesInput.checked = false;
      if (state.layService === "ja") state.layService = "";
    }
  }

  function applyLeg(available, regio) {
    state.legAvailable = available === true ? true : (available === false ? false : null);
    if (state.legAvailable === true) {
      setLegStatus(regio ? "Beschikbaar in " + regio : "Legservice beschikbaar in jouw regio", "ok");
    } else if (state.legAvailable === false) {
      setLegStatus("In jouw regio verzorgen we de legservice op dit moment nog niet. De rest van je offerte rekenen we gewoon voor je uit.", "no");
    } else {
      setLegStatus("Vul je postcode in om te zien of we in jouw regio leggen.", "prompt");
    }
    setLegYesEnabled(state.legAvailable === true);
    updateNav();
  }

  function checkLegservice() {
    if (!legPostcodeInput) return;
    const pc = String(legPostcodeInput.value || "").trim();
    // Zelfde postcode én al een definitief antwoord → niet opnieuw checken. Anders herstart een
    // blur (bv. door op "Ja" te klikken) de check en wist die de zojuist gemaakte keuze.
    if (pc === legLastPc && state.legAvailable !== null) return;
    state.legPostcode = pc;
    // Postcode meteen doorzetten naar de contactstap zodat de klant 'm niet 2x typt.
    if (contactPostcodeInput && contactPostcodeInput.value.trim() !== pc) {
      contactPostcodeInput.value = pc;
      updateHidden();
    }
    const digits = (pc.match(/\d/g) || []).length;
    if (digits < 4) { applyLeg(null); return; }
    setLegStatus("Beschikbaarheid controleren…", "checking");
    setLegYesEnabled(false);
    state.legAvailable = null;
    updateNav();
    const seq = ++legSeq;
    fetch(LEGSERVICE_ENDPOINT + "?postcode=" + encodeURIComponent(pc), { headers: { Accept: "application/json" } })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("legservice " + r.status))))
      .then((data) => { if (seq === legSeq) { legLastPc = pc; applyLeg(!!(data && data.beschikbaar), data && data.regio); } })
      .catch(() => { if (seq === legSeq) { legLastPc = pc; applyLeg(true); } }); // fail-open: nooit een lead blokkeren bij een storing
  }

  function seedLegPostcode() {
    if (!legPostcodeInput) return;
    if (!legPostcodeInput.value.trim() && contactPostcodeInput && contactPostcodeInput.value.trim()) {
      legPostcodeInput.value = contactPostcodeInput.value.trim();
    }
    if (legPostcodeInput.value.trim()) checkLegservice();
    else applyLeg(null);
  }

  if (legPostcodeInput) {
    legPostcodeInput.addEventListener("input", () => {
      clearTimeout(legTimer);
      legTimer = setTimeout(checkLegservice, 400);
    });
    legPostcodeInput.addEventListener("blur", checkLegservice);
  }

  function clamp(value, min, max) {
    const number = parseInt(value, 10);
    if (Number.isNaN(number)) return min;
    return Math.min(max, Math.max(min, number));
  }

  function syncSurface(value) {
    state.surface = clamp(value, 50, 500);
    surfaceInput.value = state.surface;
    surfaceRange.value = state.surface;
    updateUi();
  }

  function syncPlinthMeters(value) {
    state.plinthMeters = clamp(value, 1, 250);
    plinthInput.value = state.plinthMeters;
    plinthRange.value = state.plinthMeters;
    updateUi();
  }

  function validateContact(showErrors) {
    let valid = true;
    root.querySelectorAll("[data-vmq-required]").forEach((field) => {
      const filled = String(field.value || "").trim().length > 0;
      const emailOk = field.type !== "email" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value);
      const ok = filled && emailOk;
      field.classList.toggle("is-invalid", showErrors && !ok);
      if (!ok) valid = false;
    });
    if (contactError) contactError.hidden = valid || !showErrors;
    return valid;
  }

  function resetAfter(key) {
    if (key === "floorType") {
      state.pattern = "";
      state.brand = "";
      state.brandChosen = false;
      state.product = "";
      root.querySelectorAll('input[name="vmq-pattern"],input[name="vmq-brand"],input[name="vmq-product"]').forEach((input) => { input.checked = false; });
      // Laminaat kent geen egalisatie: eerdere egaliseren-keuze wissen zodat hij niet in de offerte belandt.
      if (state.floorType === "laminaat") {
        state.leveling = "";
        state.subfloor = "";
        state.levelMm = "";
        root.querySelectorAll('input[name="vmq-leveling"],input[name="vmq-subfloor"],input[name="vmq-level-mm"]').forEach((input) => { input.checked = false; });
      }
    }
    if (key === "pattern" || key === "brand") {
      state.product = "";
      root.querySelectorAll('input[name="vmq-product"]').forEach((input) => { input.checked = false; });
    }
    if (key === "leveling" && state.leveling !== "ja") {
      state.subfloor = "";
      state.levelMm = "";
      root.querySelectorAll('input[name="vmq-subfloor"],input[name="vmq-level-mm"]').forEach((input) => { input.checked = false; });
    }
    if (key === "plinth" && state.plinth === "none") {
      state.plinthMount = "";
      root.querySelectorAll('input[name="vmq-plinth-mount"]').forEach((input) => { input.checked = false; });
    }
    // Geen legservice → geen montage: montagekeuze wissen zodat hij niet meegestuurd wordt.
    if (key === "layService" && state.layService !== "ja") {
      state.plinthMount = "";
      root.querySelectorAll('input[name="vmq-plinth-mount"]').forEach((input) => { input.checked = false; });
    }
  }

  function updateHidden() {
    const product = getSelectedProduct();
    const plinth = getSelectedPlinth();
    const firstName = root.querySelector("[data-vmq-first-name]")?.value || "";
    const lastName = root.querySelector("[data-vmq-last-name]")?.value || "";
    const prefix = root.querySelector("[data-vmq-phone-prefix]")?.value || "";
    const phone = root.querySelector("[data-vmq-phone-number]")?.value || "";

    const hidden = {
      name: `${firstName} ${lastName}`.trim(),
      phone: `${prefix} ${phone}`.trim(),
      floorType: selectedLabel("floorType"),
      pattern: selectedLabel("pattern"),
      brand: state.brand || (state.brandChosen ? "Geen voorkeur" : ""),
      product: product ? product.title : (state.product === "advies" || state.floorType === "advies" ? "Advies gewenst" : ""),
      productVariant: product ? product.variantId : "",
      productSku: product ? product.sku : "",
      surface: String(state.surface || ""),
      layService: selectedLabel("layService"),
      leveling: selectedLabel("leveling"),
      subfloor: state.subfloor || "",
      levelMm: state.levelMm || "",
      plinth: plinth ? plinth.title : "",
      plinthVariant: plinth && plinth.variantId !== "none" ? plinth.variantId : "",
      plinthSku: plinth ? plinth.sku : "",
      plinthMeters: state.plinth && state.plinth !== "none" ? String(state.plinthMeters || "") : "",
      plinthMount: state.layService === "ja" && state.plinth && state.plinth !== "none" ? state.plinthMount : "",
      body: buildBody()
    };

    Object.entries(hidden).forEach(([key, value]) => {
      const el = root.querySelector(`[data-vmq-hidden="${key}"]`);
      if (el) el.value = value;
    });
  }

  function buildBody() {
    const product = getSelectedProduct();
    const plinth = getSelectedPlinth();
    const note = root.querySelector("[data-vmq-note]")?.value || "";
    const lines = [
      "Nieuwe offerte-aanvraag",
      "",
      `Vloersoort: ${selectedLabel("floorType") || "-"}`,
      `Legpatroon: ${selectedLabel("pattern") || "-"}`,
      `Merk: ${state.brand || (state.brandChosen ? "Geen voorkeur" : "-")}`,
      `Product: ${product ? product.title : (state.product === "advies" || state.floorType === "advies" ? "Advies gewenst" : "-")}`,
      `SKU product: ${product ? product.sku || "-" : "-"}`,
      `Oppervlakte: ${state.surface || "-"} m2`,
      `Legservice: ${selectedLabel("layService") || "-"}`,
      // Laminaat wordt nooit geëgaliseerd → egalisatieregels weglaten uit de offerte.
      ...(state.floorType === "laminaat" ? [] : [
        `Egaliseren: ${selectedLabel("leveling") || "-"}`,
        `Dekvloer: ${state.subfloor || "-"}`,
        `Aantal mm egaliseren: ${state.levelMm || "-"}`,
      ]),
      `Plint: ${plinth ? plinth.title : "-"}`,
      `SKU plint: ${plinth ? plinth.sku || "-" : "-"}`,
      `Meters plint: ${state.plinth && state.plinth !== "none" ? state.plinthMeters : "-"}`,
      `Plintmontage: ${state.layService === "ja" && state.plinth && state.plinth !== "none" ? state.plinthMount || "-" : "-"}`,
      "",
      `Opmerking: ${note || "-"}`
    ];
    return lines.join("\n");
  }

  root.addEventListener("change", (event) => {
    const input = event.target.closest("[data-vmq-input]");
    if (!input) return;
    const key = input.dataset.vmqInput;
    state[key] = input.value;
    // "Geen voorkeur" bij merk: geldige keuze, maar leeg merk = alle merken tonen.
    if (key === "brand") {
      state.brandChosen = true;
      if (state.brand === "geen-voorkeur") state.brand = "";
    }
    resetAfter(key);
    // Zodra het patroon bekend is de merkenlijst alvast ophalen (dient meteen als bron
    // voor merkfilter én "geen voorkeur"-productlijst); bij een merkkeuze de producten
    // alvast op de achtergrond laden zodat stap 4 direct opent.
    if (key === "pattern") filterBrands();
    if (key === "brand" && state.floorType && state.floorType !== "advies") {
      fetchList(state.floorType, state.pattern, state.brand).catch(() => {});
    }
    if (key === "floorType" || key === "pattern" || key === "brand") renderProducts();
    updateUi();
  });

  root.querySelectorAll("[data-vmq-next]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!isValidStep(currentStep)) {
        updateNav();
        return;
      }
      const order = activeOrder();
      const index = order.indexOf(currentStep);
      showStep(order[Math.min(index + 1, order.length - 1)]);
    });
  });

  root.querySelectorAll("[data-vmq-prev]").forEach((button) => {
    button.addEventListener("click", () => {
      const order = activeOrder();
      const index = order.indexOf(currentStep);
      showStep(order[Math.max(index - 1, 0)]);
    });
  });

  [surfaceInput, surfaceRange].forEach((el) => {
    if (el) el.addEventListener("input", () => syncSurface(el.value));
  });
  [plinthInput, plinthRange].forEach((el) => {
    if (el) el.addEventListener("input", () => syncPlinthMeters(el.value));
  });

  root.querySelectorAll("[data-vmq-required],[data-vmq-note],[data-vmq-phone-prefix]").forEach((el) => {
    el.addEventListener("input", updateHidden);
    el.addEventListener("change", updateHidden);
  });

  // Info-tooltips: i-knop opent de uitlegballon (klik werkt ook op mobiel); klik elders
  // of op een andere i-knop sluit hem. preventDefault voorkomt dat de radio meeklikt.
  root.addEventListener("click", (event) => {
    const info = event.target.closest(".vmq-info");
    if (info) {
      event.preventDefault();
      event.stopPropagation();
      const option = info.closest(".vmq-option");
      const wasOpen = option.classList.contains("tip-open");
      root.querySelectorAll(".vmq-option.tip-open").forEach((o) => o.classList.remove("tip-open"));
      if (!wasOpen) option.classList.add("tip-open");
      return;
    }
    if (!event.target.closest(".vmq-tip")) {
      root.querySelectorAll(".vmq-option.tip-open").forEach((o) => o.classList.remove("tip-open"));
    }
  });

  // Plus/min naast het getal: de slider (500 stappen op ±500px) maakt precies 49 of 51
  // kiezen vrijwel onmogelijk; hiermee kan het altijd per 1 omhoog of omlaag.
  root.querySelectorAll("[data-vmq-stepper]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const delta = parseInt(btn.dataset.vmqDelta || "0", 10);
      if (btn.dataset.vmqStepper === "plinth") syncPlinthMeters(state.plinthMeters + delta);
      else syncSurface(state.surface + delta);
    });
  });

  // Browsers herstellen formulierkeuzes bij een herbezoek/refresh (sessieherstel), maar
  // de JS-state start dan leeg: de oude keuze staat aangevinkt terwijl "Volgende"
  // uitgeschakeld blijft. Lees aangevinkte keuzes en getallen daarom terug in de state.
  function hydrateFromDom() {
    root.querySelectorAll("input[data-vmq-input]:checked").forEach((input) => {
      const key = input.dataset.vmqInput;
      if (!input.value) return;
      state[key] = input.value;
      if (key === "brand") {
        state.brandChosen = true;
        if (state.brand === "geen-voorkeur") state.brand = "";
      }
    });
    if (surfaceInput && surfaceInput.value && parseInt(surfaceInput.value, 10) !== state.surface) syncSurface(surfaceInput.value);
    if (plinthInput && plinthInput.value && parseInt(plinthInput.value, 10) !== state.plinthMeters) syncPlinthMeters(plinthInput.value);
    seedLegPostcode();
    updateUi();
  }
  // pageshow dekt zowel bfcache-terugnavigatie als laat formulierherstel na init.
  window.addEventListener("pageshow", hydrateFromDom);

  // Aanvraag → Mastermind-intake (maakt een offerte-concept). Zelfde worker-host als de
  // productenlijst; de bedankpagina komt uit data-success op de sectie.
  const AANVRAAG_ENDPOINT = OFFERTE_ENDPOINT.replace("/producten", "/aanvraag");
  const SUCCESS_URL = root.dataset.success || "/pages/bedankt-offerte-aanvraag";

  function verzamelAanvraag() {
    const product = getSelectedProduct();
    const plinth = getSelectedPlinth();
    const val = (sel) => { const el = root.querySelector(sel); return el ? String(el.value || "").trim() : ""; };
    const prefix = val("[data-vmq-phone-prefix]");
    const phone = val("[data-vmq-phone-number]");
    return {
      vloersoort: state.floorType,
      legpatroon: state.pattern,
      merk: state.brand,
      productVariantId: product ? product.variantId : "",
      productSku: product ? product.sku : "",
      productTitel: product ? product.title : (state.floorType === "advies" || state.product === "advies" ? "Advies gewenst" : ""),
      m2: state.surface,
      legservice: state.layService === "ja",
      egaliseren: state.leveling === "ja",
      egalisatieMm: state.levelMm,
      dekvloer: state.subfloor,
      plintVariantId: plinth && plinth.variantId !== "none" ? plinth.variantId : "",
      plintSku: plinth ? plinth.sku : "",
      plintTitel: plinth ? plinth.title : "",
      plintMeters: state.plinth && state.plinth !== "none" ? state.plinthMeters : 0,
      plintmontage: state.layService === "ja" ? state.plinthMount : "",
      klant: {
        voornaam: val("[data-vmq-first-name]"),
        achternaam: val("[data-vmq-last-name]"),
        bedrijfsnaam: val("[data-vmq-company]"),
        email: val("[data-vmq-email]"),
        telefoon: (prefix + " " + phone).trim(),
        postcode: val('[name="contact[postcode]"]'),
        huisnummer: val('[name="contact[huisnummer]"]'),
        woonplaats: val('[name="contact[woonplaats]"]'),
        straatnaam: val('[name="contact[straatnaam]"]'),
        land: "Nederland"
      },
      opmerking: val("[data-vmq-note]")
    };
  }

  // Native verzenden volledig blokkeren: Shopify's hCaptcha onderschept submits en
  // herhaalt ze via form.submit() (dat langs alle listeners gaat) → lege post naar
  // Shopify + herladen pagina. De knop is daarom type="button" en form.submit is
  // onklaar gemaakt; Enter in een veld loopt via dezelfde nette route.
  if (form) form.submit = function () {};

  async function verstuurAanvraag() {
    updateHidden();
    if (!validateContact(true)) return;

    const submitBtn = form.querySelector(".vmq-btn--submit");
    if (submitBtn) { submitBtn.dataset.orig = submitBtn.textContent; submitBtn.disabled = true; submitBtn.textContent = "Versturen…"; }
    if (window.dataLayer) {
      window.dataLayer.push({ event: "offerte_submitted", floorType: selectedLabel("floorType"), pattern: selectedLabel("pattern"), brand: state.brand || "", surface: state.surface });
    }
    try {
      const res = await fetch(AANVRAAG_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(verzamelAanvraag())
      });
      if (!res.ok) throw new Error("aanvraag " + res.status);
      window.location.href = SUCCESS_URL;
    } catch (e) {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.orig || "Ontvang jouw prijs"; }
      if (contactError) { contactError.hidden = false; contactError.textContent = "Versturen is niet gelukt. Probeer het zo nog eens."; }
    }
  }

  root.querySelectorAll("[data-vmq-submit]").forEach((btn) => {
    btn.addEventListener("click", () => { verstuurAanvraag(); });
  });
  if (form) {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      verstuurAanvraag();
    });
  }

  // MODAL-MODUS (productpagina): de bestaande "Offerte aanvragen"-knop (#btn_quote)
  // opent deze module als overlay. Capture-fase + stopPropagation zodat de oude
  // offerte-modal (quote.js, zelfde knop) niet meer meeluistert.
  const isModal = root.classList.contains("vmq--modal");
  if (isModal) {
    // Verhuis de overlay naar <body>: een voorouder met transform/filter maakt van
    // position:fixed anders een lokaal kader, waardoor de modal niet over de
    // site-header valt. De sectie-CSS werkt op id en blijft gewoon gelden.
    document.body.appendChild(root);
    const openModule = () => {
      root.classList.add("is-open");
      document.documentElement.style.overflow = "hidden";
      const a = parseInt(document.querySelector("#areaInput")?.value || "", 10);
      if (!Number.isNaN(a) && a > 0) syncSurface(a); // m² live uit de rekenhulp
      root.scrollTop = 0;
    };
    const closeModule = () => {
      root.classList.remove("is-open");
      document.documentElement.style.overflow = "";
    };
    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("#btn_quote, [data-vmq-open]");
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        openModule();
        return;
      }
      if (event.target === root) closeModule(); // klik op de achtergrond sluit
    }, true);
    root.querySelectorAll("[data-vmq-close]").forEach((btn) => btn.addEventListener("click", closeModule));
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && root.classList.contains("is-open")) closeModule();
    });
  }

  // API-warmup op idle: een piepkleine aanvraag maakt de server (en zijn catalogus-cache)
  // wakker vóór de klant bij de merk-/productstap is; koude starts voelen anders traag.
  (window.requestIdleCallback || ((f) => setTimeout(f, 1200)))(() => {
    fetchList("hybride-hout", "", "").catch(() => {});
  });

  // Alle stap-achtergronden op idle voorladen: wisselen van stap toont de foto dan direct
  // in plaats van eerst de kale gradient (het "verspringen" bij stapwissels).
  if (root.getAttribute("data-design") === "2") {
    const warmBackgrounds = () => {
      steps.forEach((step) => {
        const bg = getComputedStyle(step).getPropertyValue("--d2bg");
        const m = bg && bg.match(/url\((['"]?)(.*?)\1\)/);
        if (m && m[2]) preload(m[2]);
      });
    };
    if ("requestIdleCallback" in window) requestIdleCallback(warmBackgrounds, { timeout: 4000 });
    else setTimeout(warmBackgrounds, 1500);
  }

  renderProducts();
  renderPlinths();
  // Product-modus: m² alvast overnemen uit de rekenhulp op de productpagina, als die er is.
  const areaVal = prefill ? parseInt(document.querySelector("#areaInput")?.value || "", 10) : NaN;
  syncSurface(!Number.isNaN(areaVal) && areaVal > 0 ? areaVal : (surfaceInput && surfaceInput.value ? surfaceInput.value : state.surface));
  syncPlinthMeters(plinthInput && plinthInput.value ? plinthInput.value : state.plinthMeters);
  hydrateFromDom();
  showStep(prefill ? "surface" : "floorType", false);
})();
